/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Progress, Form } from 'antd';
import classNames from 'classnames';
import moment from 'moment';
import { Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import StepWizard from 'react-step-wizard';
import IconBack from '../../../assets/Images/icons/icon-back';
import ModalDiscardChanges from '../../../components/Shared/modal/discardChanges';
import { ROUTER } from '../../../constants/router';
import useNotify from '../../../context/Notification/useNotify';
import DCDPOService from '../../../services/DCDPO.service';
import { useBlocker } from '../../../util/usePrompt';

import Step1 from './component/Step1';
import Step2 from './component/Step2';
import Step3 from './component/Step3';
import Step4 from './component/Step4';
import Step5 from './component/Step5';
import Step6 from './component/Step6';
import Step7 from './component/Step7';
import Step8 from './component/Step8';
import StepList from './component/StepList';
import StepPreview from './component/StepPreview';
import HRPolicyService from '../../../services/HRPolicy.service';
import GlobalService from '../../../services/Global.service';
import { POLICY_NAME } from '../POLICY';

const { Provider } = Form;

export default function HRDetail() {
    const { t, i18n } = useTranslation();
    const lang = i18n.language;
    let navigate = useNavigate();
    const location = useLocation();
    const { id } = useParams();
    const notify = useNotify();

    const [data] = useState([
        { name: 'Define the policy name and organization information', key: 1 },
        { name: 'Introduction and Lawful Basis', key: 2 },
        { name: 'Personal Data Collected and Source', key: 3 },
        { name: 'Reason for collected data', key: 4 },
        { name: 'Who we will disclose or transfer personal data', key: 5 },
        { name: 'How long and how we retain personal data?', key: 6 },
        { name: 'Data Subject Rights', key: 7 },
        { name: 'Policy change and contact channels', key: 8 },
    ]);

    const [state, updateState] = useState();
    const [applications, setApplications] = useState([]);

    const [currentSelectList, setCurrentSelectList] = useState(1);
    const [loading, setLoading] = useState(false);
    const [loading_, setLoadingSave] = useState(false);
    const [fixed, setFixed] = useState(false);
    const [editData, setEditData] = useState();
    const [editMode] = useState(false);
    const [dsType, setDsType] = useState([]);

    // check validations
    const [step1, setStep1] = useState(false);
    const [step2, setStep2] = useState(false);
    const [step3, setStep3] = useState(false);
    const [step4, setStep4] = useState(false);
    const [step5, setStep5] = useState(false);
    const [step6, setStep6] = useState(false);
    const [step7, setStep7] = useState(false);
    const [step8, setStep8] = useState(false);

    // form
    const [hrPrivacyPolicy] = Form.useForm();
    const [hrIntroductionLawfulBasis] = Form.useForm();
    const [hrPersonalDataCollect] = Form.useForm();
    const [hrReasonCollectedData] = Form.useForm();
    const [hrTransferPersonalData] = Form.useForm();
    const [hrRetainPersonalData] = Form.useForm();
    const [hrDataSubjectRight] = Form.useForm();
    const [hrPolicyChange] = Form.useForm();
    const [preview] = Form.useForm();

    const [submitData, setSubmitData] = useState({});

    //Discard change
    const [change, setChange] = useState(false);
    const [openChange, setOpenChange] = useState(false);
    const [nextLocation, setNextLocation] = useState(null);
    const [isChangeLocation, setIsChangeLocation] = useState(false);

    useBlocker((nextLocation) => onChangePage(nextLocation), change);

    const onChangePage = (nextLocation) => {
        setOpenChange(true);
        setIsChangeLocation(true);
        setNextLocation(nextLocation);
    };

    const handelOk = () => {
        setOpenChange(false);
        setChange(false);
    };

    const handelOkLocation = async () => {
        await setOpenChange(false);
        await setChange(false);
        await setIsChangeLocation(false);
        await navigate(
            nextLocation.location.pathname + nextLocation.location.search
        );
    };

    const onFormChange = (_, info) => {
        if (info.changedFields.length > 0) {
            setChange(true);
        }
    };

    const onFormFinish = async (name, info) => {
        const values = info?.values;
        const dsTypeList = [];
        hrPrivacyPolicy
            ?.getFieldValue('hrPrivacyPolicyDataSubjectType')
            ?.forEach((val) => {
                const item = dsType?.filter((res) => res?.value === val)[0];
                const privacyId =
                    editData?.hrPrivacyPolicy?.hrPrivacyPolicyDataSubjectType?.find(
                        (res) => res?.hrDataSubjectId === val
                    )?.hrDataSubjectId;
                dsTypeList?.push({
                    hrPrivacyPolicyDataSubjectTypeId: privacyId,
                    hrDataSubjectId: item?.value,
                    hrDataSubjectNameTh: item?.title,
                    hrDataSubjectNameEn: item?.title,
                });
            });
        const form = {
            hrPrivacyPolicy: {
                ...hrPrivacyPolicy?.getFieldsValue(),
                hrPrivacyPolicyId: id === 'new' ? undefined : id,
                hrPrivacyPolicyDataSubjectType: dsTypeList,
                hrEffectiveDate: hrPrivacyPolicy?.getFieldValue(
                    'hrEffectiveDate'
                )
                    ? hrPrivacyPolicy
                          ?.getFieldValue('hrEffectiveDate')
                          ?.format('YYYY-MM-DDT00:00:00.000+00:00')
                    : '',
                isPublish: true,
            },
            hrIntroductionLawfulBasis: {
                ...hrIntroductionLawfulBasis?.getFieldsValue(),
                hrIntroductionLawfulBasisId:
                    editData?.hrIntroductionLawfulBasis
                        ?.hrIntroductionLawfulBasisId,
                hrIntroductionIsDisplay: values?.hrIntroductionIsDisplay,
                hrLawfulBasisIsDisplay: values?.hrLawfulBasisIsDisplay,
            },
            hrPersonalDataCollect: {
                ...hrPersonalDataCollect?.getFieldsValue(),
                hrPersonalDataCollectId:
                    editData?.hrPersonalDataCollect?.hrPersonalDataCollectId,
                hrPersonalDataIsDisplay: values?.hrPersonalDataIsDisplay,
                hrSourceIsDisplay: values?.hrSourceIsDisplay,
            },
            hrReasonCollectedData: {
                ...hrReasonCollectedData?.getFieldsValue(),
                hrReasonCollectedDataId:
                    editData?.hrReasonCollectedData?.hrReasonCollectedDataId,
                hrPurposeIsDisplay: values?.hrPurposeIsDisplay,
            },
            hrTransferPersonalData: {
                ...hrTransferPersonalData?.getFieldsValue(),
                hrTransferPersonalDataId:
                    editData?.hrTransferPersonalData?.hrReasonCollectedDataId,
                hrDisclosureIsDisplay: values?.hrDisclosureIsDisplay,
                hrInternationalIsDisplay: values?.hrInternationalIsDisplay,
            },
            hrRetainPersonalData: {
                ...hrRetainPersonalData?.getFieldsValue(),
                hrRetainPersonalDataId:
                    editData?.hrRetainPersonalData?.hrRetainPersonalDataId,
                hrRetentionIsDisplay: values?.hrRetentionIsDisplay,
                hrSecurityIsDisplay: values?.hrSecurityIsDisplay,
            },
            hrDataSubjectRight: {
                ...hrDataSubjectRight?.getFieldsValue(),
                hrDataSubjectRightId:
                    editData?.hrDataSubjectRight?.hrDataSubjectRightId,
                hrDataSubjectRightIsDisplay:
                    values?.hrDataSubjectRightIsDisplay,
            },
            hrPolicyChange: {
                ...hrPolicyChange?.getFieldsValue(),
                hrPolicyChangeId: editData?.hrPolicyChange?.hrPolicyChangeId,
                hrChangeIsDisplay: values?.hrChangeIsDisplay,
                hrDataControllerIsDisplay: values?.hrDataControllerIsDisplay,
                hrDataProtectionIsDisplay: values?.hrDataProtectionIsDisplay,
            },
        };
        try {
            setChange(false);
            setOpenChange(false);
            setLoadingSave(true);
            const { data } = await HRPolicyService.saveHRPolicy(form);
            if (data?.resultCode === 1) {
                notify({
                    title: t('common.Success'),
                    description: t('Successfully saved data'),
                });
                navigate(
                    `${ROUTER.POLICY.DEFAULT}?tab=${POLICY_NAME.HR_POLICY}`
                );
            } else {
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('common.FailedSaveData'),
                });
            }
        } catch (error) {
            notify({
                type: 'error',
                title: t('common.Fail'),
                description: t('common.FailedSaveData'),
            });
        }
    };

    useEffect(() => {
        const current = location.hash.replace('#step', '');
        if (current) {
            setCurrentSelectList(Number(current));
        }
        if (current === '9') {
            setFixed(false);
        }
    }, [location]);

    const setInstance = (SW) =>
        updateState({
            ...state,
            SW,
        });

    const passStep =
        step1 & step2 & step3 & step4 & step5 & step6 & step7 & step8;
    const filter = [
        step1,
        step2,
        step3,
        step4,
        step5,
        step6,
        step7,
        step8,
    ].filter(Boolean).length;
    const currentProgress = ((filter * 100) / 8).toFixed(0);

    const getHRDetail = async (id) => {
        try {
            setLoading(true);
            const { data } = await HRPolicyService.getHRPolicyDetail(id);
            const res = data?.resultData;
            const dateItem = res?.hrPrivacyPolicy?.effectiveDate?.split(' ');
            const day = dateItem[0]?.split('/')[0];
            const month = dateItem[0]?.split('/')[1];
            const year = dateItem[0]?.split('/')[2];
            const effDate = new Date(
                `${year}-${month}-${day}T${dateItem[1]}:00.000Z`
            );
            setEditData({
                hrPrivacyPolicy: {
                    ...res?.hrPrivacyPolicy,
                    hrEffectiveDate: res?.hrPrivacyPolicy?.effectiveDate
                        ? moment(effDate)
                        : null,
                },
                hrIntroductionLawfulBasis: {
                    ...res?.hrIntroductionLawfulBasis,
                },
                hrPersonalDataCollect: {
                    ...res?.hrPersonalDataCollect,
                },
                hrReasonCollectedData: {
                    ...res?.hrReasonCollectedData,
                },
                hrTransferPersonalData: {
                    ...res?.hrTransferPersonalData,
                },
                hrRetainPersonalData: {
                    ...res?.hrRetainPersonalData,
                },
                hrDataSubjectRight: {
                    ...res?.hrDataSubjectRight,
                },
                hrPolicyChange: {
                    ...res?.hrPolicyChange,
                },
            });
            const dsTypeId = [];
            res?.hrPrivacyPolicy?.hrPrivacyPolicyDataSubjectType?.forEach(
                (val) => {
                    dsTypeId?.push(val?.hrDataSubjectId);
                }
            );
            hrDataSubjectRight?.setFieldsValue({
                ...res?.hrDataSubjectRight,
            });
            hrIntroductionLawfulBasis?.setFieldsValue({
                ...res?.hrIntroductionLawfulBasis,
            });
            hrPersonalDataCollect?.setFieldsValue({
                ...res?.hrPersonalDataCollect,
            });
            hrPolicyChange?.setFieldsValue({
                ...res?.hrPolicyChange,
            });
            hrPrivacyPolicy?.setFieldsValue({
                ...res?.hrPrivacyPolicy,
                hrPrivacyPolicyDataSubjectType: dsTypeId,
                hrEffectiveDate: res?.hrPrivacyPolicy?.effectiveDate
                    ? moment(effDate)
                    : null,
            });
            hrReasonCollectedData?.setFieldsValue({
                ...res?.hrReasonCollectedData,
            });
            hrRetainPersonalData?.setFieldsValue({
                ...res?.hrRetainPersonalData,
            });
            hrTransferPersonalData?.setFieldsValue({
                ...res?.hrTransferPersonalData,
            });
            preview?.setFieldsValue({
                hrChangeIsDisplay: res?.hrPolicyChange?.hrChangeIsDisplay,
                hrDataControllerIsDisplay:
                    res?.hrPolicyChange?.hrDataControllerIsDisplay,
                hrDataProtectionIsDisplay:
                    res?.hrPolicyChange?.hrDataProtectionIsDisplay,
                hrDataSubjectRightIsDisplay:
                    res?.hrDataSubjectRight?.hrDataSubjectRightIsDisplay,
                hrDisclosureIsDisplay:
                    res?.hrTransferPersonalData?.hrDisclosureIsDisplay,
                hrInternationalIsDisplay:
                    res?.hrTransferPersonalData?.hrInternationalIsDisplay,
                hrIntroductionIsDisplay:
                    res?.hrIntroductionLawfulBasis?.hrIntroductionIsDisplay,
                hrLawfulBasisIsDisplay:
                    res?.hrIntroductionLawfulBasis?.hrLawfulBasisIsDisplay,
                hrPersonalDataIsDisplay:
                    res?.hrPersonalDataCollect?.hrPersonalDataIsDisplay,
                hrPurposeIsDisplay:
                    res?.hrReasonCollectedData?.hrPurposeIsDisplay,
                hrRetentionIsDisplay:
                    res?.hrRetainPersonalData?.hrRetentionIsDisplay,
                hrSecurityIsDisplay:
                    res?.hrRetainPersonalData?.hrSecurityIsDisplay,
                hrSourceIsDisplay:
                    res?.hrPersonalDataCollect?.hrSourceIsDisplay,
            });
            setSubmitData({
                hrPrivacyPolicy: {
                    ...res?.hrPrivacyPolicy,
                    hrEffectiveDate:
                        res?.hrPrivacyPolicy?.effectiveDate?.split(' ')[0],
                },
                hrIntroductionLawfulBasis: {
                    ...res?.hrIntroductionLawfulBasis,
                },
                hrPersonalDataCollect: {
                    ...res?.hrPersonalDataCollect,
                },
                hrReasonCollectedData: {
                    ...res?.hrReasonCollectedData,
                },
                hrTransferPersonalData: {
                    ...res?.hrTransferPersonalData,
                },
                hrRetainPersonalData: {
                    ...res?.hrRetainPersonalData,
                },
                hrDataSubjectRight: {
                    ...res?.hrDataSubjectRight,
                },
                hrPolicyChange: {
                    ...res?.hrPolicyChange,
                },
            });
            setOpenChange(false);
            setChange(false);
            setLoading(false);
        } catch (error) {
            console.log(error);
        }
    };

    const getDsTypeDropdown = async () => {
        try {
            const { data } = await GlobalService.getDs();
            if (data?.resultData) {
                let option = [];
                data?.resultData?.dataSubjectType?.forEach((element) => {
                    option.push({
                        title: lang === 'en' ? element.nameEn : element?.nameTh,
                        value: element?.id,
                    });
                });
                setDsType(option);
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        getDsTypeDropdown();
        if (id !== 'new') getHRDetail(id);
        else getDCDPO();
    }, [id]);

    const getDCDPO = async () => {
        try {
            const { data } = await DCDPOService.getDCDPO();
            const item = data?.resultData;
            if (item) {
                hrPolicyChange.setFieldsValue({
                    hrDataControllerContentTh: `${item?.nameDPOTh}</br>${item?.addressTh}`,
                    hrDataControllerContentEn: `${item?.nameDPOEn}</br>${item?.addressEn}`,
                    hrDataProtectionContentTh: `${item?.staffNameDPOTh}`,
                    hrDataProtectionContentEn: `${item?.staffNameDPOTh}`,
                });
                setChange(false);
                setOpenChange(false);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const saveDraft = async (e) => {
        try {
            const display = preview?.getFieldsValue();
            const dsTypeList = [];
            hrPrivacyPolicy
                ?.getFieldValue('hrPrivacyPolicyDataSubjectType')
                ?.forEach((val) => {
                    const item = dsType?.filter((res) => res?.value === val)[0];
                    const privacyId =
                        editData?.hrPrivacyPolicy?.hrPrivacyPolicyDataSubjectType?.find(
                            (res) => res?.hrDataSubjectId === val
                        )?.hrDataSubjectId;
                    dsTypeList?.push({
                        hrPrivacyPolicyDataSubjectTypeId: privacyId,
                        hrDataSubjectId: item?.value,
                        hrDataSubjectNameTh: item?.title,
                        hrDataSubjectNameEn: item?.title,
                    });
                });
            const form = {
                hrPrivacyPolicy: {
                    ...hrPrivacyPolicy?.getFieldsValue(),
                    hrPrivacyPolicyId: id === 'new' ? undefined : id,
                    hrPrivacyPolicyDataSubjectType: dsTypeList,
                    hrEffectiveDate: hrPrivacyPolicy?.getFieldValue(
                        'hrEffectiveDate'
                    )
                        ? hrPrivacyPolicy
                              ?.getFieldValue('hrEffectiveDate')
                              ?.format('YYYY-MM-DDT00:00:00.000+00:00')
                        : '',
                    isPublish: false,
                },
                hrIntroductionLawfulBasis: {
                    ...hrIntroductionLawfulBasis?.getFieldsValue(),
                    hrIntroductionLawfulBasisId:
                        editData?.hrIntroductionLawfulBasis
                            ?.hrIntroductionLawfulBasisId,
                    hrIntroductionIsDisplay: display?.hrIntroductionIsDisplay,
                    hrLawfulBasisIsDisplay: display?.hrLawfulBasisIsDisplay,
                },
                hrPersonalDataCollect: {
                    ...hrPersonalDataCollect?.getFieldsValue(),
                    hrPersonalDataCollectId:
                        editData?.hrPersonalDataCollect
                            ?.hrPersonalDataCollectId,
                    hrPersonalDataIsDisplay: display?.hrPersonalDataIsDisplay,
                    hrSourceIsDisplay: display?.hrSourceIsDisplay,
                },
                hrReasonCollectedData: {
                    ...hrReasonCollectedData?.getFieldsValue(),
                    hrReasonCollectedDataId:
                        editData?.hrReasonCollectedData
                            ?.hrReasonCollectedDataId,
                    hrPurposeIsDisplay: display?.hrPurposeIsDisplay,
                },
                hrTransferPersonalData: {
                    ...hrTransferPersonalData?.getFieldsValue(),
                    hrTransferPersonalDataId:
                        editData?.hrTransferPersonalData
                            ?.hrReasonCollectedDataId,
                    hrDisclosureIsDisplay: display?.hrDisclosureIsDisplay,
                    hrInternationalIsDisplay: display?.hrInternationalIsDisplay,
                },
                hrRetainPersonalData: {
                    ...hrRetainPersonalData?.getFieldsValue(),
                    hrRetainPersonalDataId:
                        editData?.hrRetainPersonalData?.hrRetainPersonalDataId,
                    hrRetentionIsDisplay: display?.hrRetentionIsDisplay,
                    hrSecurityIsDisplay: display?.hrSecurityIsDisplay,
                },
                hrDataSubjectRight: {
                    ...hrDataSubjectRight?.getFieldsValue(),
                    hrDataSubjectRightId:
                        editData?.hrDataSubjectRight?.hrDataSubjectRightId,
                    hrDataSubjectRightIsDisplay:
                        display?.hrDataSubjectRightIsDisplay,
                },
                hrPolicyChange: {
                    ...hrPolicyChange?.getFieldsValue(),
                    hrPolicyChangeId:
                        editData?.hrPolicyChange?.hrPolicyChangeId,
                    hrChangeIsDisplay: display?.hrChangeIsDisplay,
                    hrDataControllerIsDisplay:
                        display?.hrDataControllerIsDisplay,
                    hrDataProtectionIsDisplay:
                        display?.hrDataProtectionIsDisplay,
                },
            };
            setChange(false);
            setOpenChange(false);
            const { data } = await HRPolicyService.saveHRPolicy(form);
            if (data?.resultCode === 1) {
                notify({
                    title: t('common.Success'),
                    description: t('Successfully saved data'),
                });
                const HRPolicyId = data?.resultData?.hrPrivacyPolicyId;
                const fullPath = window.location.href;
                const step = fullPath?.split('#')[1];
                getHRDetail(HRPolicyId);
                navigate(ROUTER?.POLICY?.HR_PRIVACY + `/${HRPolicyId}#${step}`);
            } else {
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('common.FailedSaveData'),
                });
            }
        } catch (error) {
            console.log(error);
            notify({
                type: 'error',
                title: t('common.Fail'),
                description: t('common.FailedSaveData'),
            });
        }
    };

    const calProgress = () => {
        const dsTypeList = [];
        hrPrivacyPolicy
            ?.getFieldValue('hrPrivacyPolicyDataSubjectType')
            ?.forEach((val) => {
                const item = dsType?.filter((res) => res?.value === val)[0];
                dsTypeList?.push({
                    hrPrivacyPolicyDataSubjectTypeId:
                        editData?.hrPrivacyPolicyDataSubjectTypeId,
                    hrDataSubjectId: item?.value,
                    hrDataSubjectNameTh: item?.title,
                    hrDataSubjectNameEn: item?.title,
                });
            });
        const display = preview?.getFieldsValue();
        const payload = {
            hrPrivacyPolicy: {
                ...submitData?.hrPrivacyPolicy,
                ...hrPrivacyPolicy?.getFieldsValue(),
                hrPrivacyPolicyId: editData?.hrPrivacyPolicyId,
                hrPrivacyPolicyDataSubjectType: dsTypeList,
                hrEffectiveDate: hrPrivacyPolicy
                    ?.getFieldValue('hrEffectiveDate')
                    ?.format('DD/MM/YYYY'),
                isPublish: false,
            },
            hrIntroductionLawfulBasis: {
                ...submitData?.hrIntroductionLawfulBasis,
                ...hrIntroductionLawfulBasis?.getFieldsValue(),
                hrIntroductionLawfulBasisId:
                    editData?.hrIntroductionLawfulBasisId,
                hrIntroductionIsDisplay: display?.hrIntroductionIsDisplay,
                hrLawfulBasisIsDisplay: display?.hrLawfulBasisIsDisplay,
            },
            hrPersonalDataCollect: {
                ...submitData?.hrPersonalDataCollect,
                ...hrPersonalDataCollect?.getFieldsValue(),
                hrPersonalDataCollectId: editData?.hrPersonalDataCollectId,
                hrPersonalDataIsDisplay: display?.hrPersonalDataIsDisplay,
                hrSourceIsDisplay: display?.hrSourceIsDisplay,
            },
            hrReasonCollectedData: {
                ...submitData?.hrReasonCollectedData,
                ...hrReasonCollectedData?.getFieldsValue(),
                hrReasonCollectedDataId: editData?.hrReasonCollectedDataId,
                hrPurposeIsDisplay: display?.hrPurposeIsDisplay,
            },
            hrTransferPersonalData: {
                ...submitData?.hrTransferPersonalData,
                ...hrTransferPersonalData?.getFieldsValue(),
                hrTransferPersonalDataId: editData?.hrReasonCollectedDataId,
                hrDisclosureIsDisplay: display?.hrDisclosureIsDisplay,
                hrInternationalIsDisplay: display?.hrInternationalIsDisplay,
            },
            hrRetainPersonalData: {
                ...submitData?.hrRetainPersonalData,
                ...hrRetainPersonalData?.getFieldsValue(),
                hrRetainPersonalDataId: editData?.hrRetainPersonalDataId,
                hrRetentionIsDisplay: display?.hrRetentionIsDisplay,
                hrSecurityIsDisplay: display?.hrSecurityIsDisplay,
            },
            hrDataSubjectRight: {
                ...submitData?.hrDataSubjectRight,
                ...hrDataSubjectRight?.getFieldsValue(),
                hrDataSubjectRightId: editData?.hrDataSubjectRightId,
                hrDataSubjectRightIsDisplay:
                    display?.hrDataSubjectRightIsDisplay,
            },
            hrPolicyChange: {
                ...submitData?.hrPolicyChange,
                ...hrPolicyChange?.getFieldsValue(),
                hrPolicyChangeId: editData?.hrPolicyChangeId,
                hrChangeIsDisplay: display?.hrChangeIsDisplay,
                hrDataControllerIsDisplay: display?.hrDataControllerIsDisplay,
                hrDataProtectionIsDisplay: display?.hrDataProtectionIsDisplay,
            },
        };
        setSubmitData(payload);
        if (!editMode) {
            // setCurrentProgress(number);
            setLoading(false);
        }
    };
    return (
        <Fragment>
            <div className="title flex items-center">
                <div
                    className="cursor-pointer mr-3 space-x-2"
                    onClick={() => {
                        navigate(
                            `${ROUTER.POLICY.DEFAULT}?tab=${POLICY_NAME.HR_POLICY}`
                        );
                        // ${PRIVACY_NAME_BY_ID[_tab.policyTypeId]}
                    }}
                >
                    <IconBack />
                    <span>
                        {id === 'new'
                            ? t('Add HR Privacy Policy', { ns: 'hr-policy' })
                            : t('Edit HR Privacy Policy', { ns: 'hr-policy' })}
                    </span>
                </div>
            </div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {t('Policy')} / {t('HR Privacy Policy')} /{' '}
                </span>
                <span>
                    {id === 'new'
                        ? t('Add HR Privacy Policy', { ns: 'hr-policy' })
                        : t('Edit HR Privacy Policy', { ns: 'hr-policy' })}
                </span>
            </div>
            <div className="mt-4 grid grid-cols-4 gap-4">
                {currentSelectList !== 9 && (
                    <StepList
                        steps={{
                            step1,
                            step2,
                            step3,
                            step4,
                            step5,
                            step6,
                            step7,
                            step8,
                        }}
                        setCurrentSelectList={() => {
                            // cannot move sp5
                        }}
                        SW={state?.SW}
                        currentSelectList={currentSelectList}
                        data={data}
                        setFixed={setFixed}
                    />
                )}
                <div
                    className={classNames({
                        'col-span-3': currentSelectList !== 9,
                        'col-span-4': currentSelectList === 9,
                    })}
                >
                    {currentSelectList !== 9 && (
                        <div className="bg-white rounded-md p-4 flex font-semibold text-base">
                            <div className="flex-1 -mt-0.5">
                                <Progress
                                    strokeColor={{
                                        '0%': '#4ACE8F',
                                        '100%': '#4ACE8F',
                                    }}
                                    percent={currentProgress}
                                    status="active"
                                    showInfo={false}
                                />
                            </div>
                            <span
                                className={`pl-6 pr-2 ${
                                    currentProgress === 0
                                        ? 'text-red-500'
                                        : 'text-green-400'
                                }`}
                            >
                                {currentProgress}% {t('succeed')}
                            </span>

                            <span>{t('filledinformation')}</span>
                        </div>
                    )}
                    <Provider
                        onFormChange={onFormChange}
                        onFormFinish={onFormFinish}
                    >
                        <div className="mt-4 bg-white rounded-md p-4 overflow-hidden">
                            <StepWizard
                                isHashEnabled
                                instance={setInstance}
                                onStepChange={(e) => {
                                    setCurrentSelectList(e.activeStep);
                                }}
                            >
                                <Step1
                                    loading={loading_}
                                    editMode={editMode}
                                    saveDraft={saveDraft}
                                    applications={applications}
                                    setApplications={setApplications}
                                    form={hrPrivacyPolicy}
                                    calProgress={calProgress}
                                    setStep1={setStep1}
                                    step1={step1}
                                    editData={editData}
                                    dsType={dsType}
                                />
                                <Step2
                                    loading={loading_}
                                    editMode={editMode}
                                    saveDraft={saveDraft}
                                    applications={applications}
                                    setApplications={setApplications}
                                    form={hrIntroductionLawfulBasis}
                                    calProgress={calProgress}
                                    setStep2={setStep2}
                                    step2={step2}
                                    editData={editData}
                                />
                                <Step3
                                    loading={loading_}
                                    editMode={editMode}
                                    saveDraft={saveDraft}
                                    applications={applications}
                                    setApplications={setApplications}
                                    form={hrPersonalDataCollect}
                                    calProgress={calProgress}
                                    setStep3={setStep3}
                                    step3={step3}
                                    editData={editData}
                                />
                                <Step4
                                    loading={loading_}
                                    editMode={editMode}
                                    saveDraft={saveDraft}
                                    applications={applications}
                                    setApplications={setApplications}
                                    form={hrReasonCollectedData}
                                    calProgress={calProgress}
                                    setStep4={setStep4}
                                    step4={step4}
                                    editData={editData}
                                />
                                <Step5
                                    loading={loading_}
                                    editMode={editMode}
                                    saveDraft={saveDraft}
                                    applications={applications}
                                    setApplications={setApplications}
                                    form={hrTransferPersonalData}
                                    calProgress={calProgress}
                                    setStep5={setStep5}
                                    step5={step5}
                                    editData={editData}
                                />
                                <Step6
                                    loading={loading_}
                                    editMode={editMode}
                                    saveDraft={saveDraft}
                                    applications={applications}
                                    setApplications={setApplications}
                                    form={hrRetainPersonalData}
                                    calProgress={calProgress}
                                    setStep6={setStep6}
                                    step6={step6}
                                    editData={editData}
                                />
                                <Step7
                                    loading={loading_}
                                    editMode={editMode}
                                    saveDraft={saveDraft}
                                    applications={applications}
                                    setApplications={setApplications}
                                    form={hrDataSubjectRight}
                                    calProgress={calProgress}
                                    setStep7={setStep7}
                                    step7={step7}
                                    editData={editData}
                                />
                                <Step8
                                    loading={loading_}
                                    editMode={editMode}
                                    saveDraft={saveDraft}
                                    form={hrPolicyChange}
                                    calProgress={calProgress}
                                    passStep={passStep}
                                    setStep8={setStep8}
                                    step8={step8}
                                    editData={editData}
                                />
                                <StepPreview
                                    saveDraft={saveDraft}
                                    form={preview}
                                    loading_={loading_}
                                    loading={loading}
                                    applications={applications}
                                    data={submitData}
                                    calProgress={calProgress}
                                    privacyNoticeId={id}
                                    editData={editData}
                                    onFormFinish={onFormFinish}
                                />
                            </StepWizard>
                        </div>
                    </Provider>
                </div>
            </div>
            <ModalDiscardChanges
                open={openChange}
                handelOk={isChangeLocation ? handelOkLocation : handelOk}
                handelClose={() => setOpenChange(false)}
            />
        </Fragment>
    );
}
